import { FRA } from "@/lib/site";
import { cn } from "@/ui/utils/cn";
import { useTranslations } from "@services/strings";
import { Fragment } from "react";

// Placeholders for the two links; split out of the translated sentence below.
const RE = "[[realEstate]]";
const CF = "[[consumer]]";

/**
 * The regulator line — entity, the two FRA licences each linked to its
 * record in the FRA register, commercial register and tax ID — printed in the footer, on the home
 * trust band, about, contact and campaign pages.
 */
export const LicenceLine = ({
  tone = "default",
  className,
}: {
  /** `inverse` for navy backgrounds. */
  tone?: "default" | "inverse";
  className?: string;
}) => {
  const { t } = useTranslations();

  const links = {
    [RE]: {
      href: FRA.realEstateFinance.record,
      label: t("site.legal.realEstate"),
    },
    [CF]: {
      href: FRA.consumerFinance.record,
      label: t("site.legal.consumer"),
    },
  };
  const sentence = t("site.legal.line", {
    entity: t("site.legal.entity"),
    realEstateNumber: FRA.realEstateFinance.licence,
    consumerNumber: FRA.consumerFinance.licence,
    commercialRegister: FRA.commercialRegister,
    taxId: FRA.taxId,
    realEstate: RE,
    consumer: CF,
  });

  return (
    <p
      className={cn(
        "text-sm",
        tone === "inverse" ? "text-slate-400" : "text-slate-600",
        className,
      )}
    >
      {sentence
        .split(/(\[\[realEstate\]\]|\[\[consumer\]\])/)
        .map((part, i) => {
          const link = links[part as keyof typeof links];
          return link ? (
            <a
              key={i}
              href={link.href}
              target="_blank"
              rel="noopener"
              className={cn(
                "underline decoration-1 underline-offset-4 transition-colors",
                tone === "inverse"
                  ? "text-slate-300 hover:text-white"
                  : "text-ink hover:text-navy-soft",
              )}
            >
              {link.label}
            </a>
          ) : (
            <Fragment key={i}>{part}</Fragment>
          );
        })}
    </p>
  );
};
